import type { BrandName } from '@/scopes/common/domain/types'

const DAYS_BEFORE_CONTACT_INFO: Record<BrandName, number> = {
  sunweb: 0,
  gogo: 0,
  eliza: 3,
}

export function getDaysBeforeContactInfo(brandName: BrandName): number {
  return DAYS_BEFORE_CONTACT_INFO[brandName]
}
